import React from 'react';

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import { Container, Row, Col } from 'react-bootstrap';
import './testimonial.css';


const Data = [
  {
      id:"1",
      Name:"Okpe ThankGod Damion",
      Role:"Director",
      Company:"Dreams & Talent",
      Testimonial:"One of the standout qualities of Yinka is his creativity. He possesses aninnate ability to think outside the box and come up with innovative solutions that not only meet but often exceed the project's requirements. His designs are not only visually appealingbut also intuitive and user-friendly, enhancing the overall user experience."

  },
  {
      id:"6",
      Name:"Muktar Baba Mohammed",
      Role:"CTO",
      Company:"Amabills Tech",
      Testimonial:"Oluwasegun has consistently demonstrated outstanding proficiency in UI/UX design, bringing creativity, innovation, and attention to detail to every project he undertakes.One of his greatest strengths is his ability to understand and incorporate client requirements while also infusing his own creative vision to produce designs that are not only aesthetically pleasing but also highly functional and user-friendly."

  },
  {
      id:"7",
      Name:"Elijah Olopade",
      Role:"CEO",
      Company:"Brainaic Ltd",
      Testimonial:"One of Yinka's standout qualities is his ability to collaborate effectively with cross-functional teams. He communicates ideas clearly and works seamlessly with developers, product managers, and other stakeholders to bring concepts to life. His positive attitude and proactive approach make him a joy to work with."

  },
 
 
]

function Testimonial() {
  return (
    <Container fluid className="MyTestimonial" >
    <Row style={{ marginTop: 1.5 + 'rem', }}>

        <Col xs={12} md={6} lg={6}>
            <div >
                <h1 className="aboutHeadingyyy" >Testimonial</h1>
                <p className="aboutHeadingParagraphyyy">
                What do clients, friends, and colleagues say about my services and behavior?</p>
                    <br/>
                   
            </div>
            <br/>
        </Col>

        <Col xs={12} md={6} lg={6}>

        <Carousel
        additionalTransfrom={0}
        arrows={false}
        autoPlaySpeed={3000}
        centerMode={false}
        className=""
        containerClass="container-with-dots"
        dotListClass=""
        draggable
        focusOnSelect={false}
        infinite
        itemClass=""
        keyBoardControl
        minimumTouchDrag={80}
        pauseOnHover
        renderArrowsWhenDisabled={false}
        renderButtonGroupOutside={false}
        renderDotsOutside={false}
        responsive={{
          desktop: {
            breakpoint: {
              max: 3000,
              min: 1024,
            },
            items: 1, // Adjusted to show 2.5 items
            partialVisibilityGutter: 30,
          },
          mobile: {
            breakpoint: {
              max: 550,
              min: 0,
            },
            items: 1,
            partialVisibilityGutter: 30,
          },
          tablet: {
            breakpoint: {
              max: 1024,
              min: 551,
            },
            items: 1,
            partialVisibilityGutter: 30,
          },
        }}
        rewind={false}
        rewindWithAnimation={false}
        rtl={false}
        shouldResetAutoplay
        showDots={true}
        sliderClass=""
        slidesToSlide={1}
        swipeable
      >
        {Data.map((item) => (
          
         <div className='myRole'>
          <h6 style={{fontFamily:"Clash Display",marginBottom:1+"rem"}}>{item.Name}</h6>
          <span 
          style={{ fontFamily: 'Jost, sans-serif',backgroundColor:"#3D3D3D",paddingTop:0.3+"rem",paddingBottom:0.3+"rem",paddingRight:0.6+"rem",paddingLeft:0.6+"rem",width:"auto",borderRadius:1+"rem",fontSize:0.75+"rem",}}>
            {item.Role} - {item.Company}
           </span><br/><br/>
           <p style={{ fontFamily: 'Jost, sans-serif'}} >
              {item.Testimonial}
           </p>
         </div>
          
    

        ))}
      
      </Carousel>
        </Col>
    </Row>
</Container>
  )
}

export default Testimonial
